<template>
    <div class="z-50 top-0 left-0 w-screen h-[calc(100vh-525px)] bg-bg flex items-center justify-center">
        <div class="flex flex-col items-center justify-center">
            <div class="relative rounded-full flex items-center justify-center animate-pulse">
                <i class="fa-thin fa-spinner-third text-2xl font-bold animate-spin text-white/50"></i>
            </div>
        </div>
    </div>
</template>
